import { getFromStorage, putInStorage } from '../utilities/storage-utilities'

export const sessionExpiredEvent = new Event('sessionExpiredEvent')
export const sessionExpiredEventName = 'sessionExpiredEvent'
export const sessionExpiredEventMessage = 'Session expired'

export const setIsAuthenticated = (isAuthenticated: boolean) => {
    putInStorage<boolean>(isAuthenticated, 'isAuthenticated')
}

export const isAuthenticated = (): boolean => {
    const isAuthenticated = getFromStorage<boolean>('isAuthenticated')

    if (isAuthenticated) {
        return true
    }

    return false
}

export const setSessionExpired = (hasExpired: boolean) => {
    putInStorage<boolean>(hasExpired, 'hasExpired')
}

export const hasSessionExpired = (): boolean => {
    const isSessionExipred = getFromStorage<boolean>('isSessionExipred')

    if (isSessionExipred) {
        return true
    }

    return false
}
